/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { actions } from '../store/storeAuth';

export default function Logout () {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.logout());
    }, []);

    return <Redirect to="/auth/login" />;
}
